export const DISABLED_SYNC_TYPE = 'DISABLED';
export const ALL_SYNC_TYPE = 'ALL';
export const INCLUSIVE_SYNC_TYPE = 'INCLUSIVE';
export const EXCLUSIVE_SYNC_TYPE = 'EXCLUSIVE';

export const SYNC_TYPE_OPTIONS = [
  { key: 'disabled', text: 'Disabled', value: DISABLED_SYNC_TYPE },
  { key: 'all', text: 'All Items', value: ALL_SYNC_TYPE },
  { key: 'inclusive', text: 'Associated + Unassigned Items', value: INCLUSIVE_SYNC_TYPE },
  { key: 'exclusive', text: 'Only Associated Items', value: EXCLUSIVE_SYNC_TYPE },
];

export const DEFAULT_SYNC_TYPE = ALL_SYNC_TYPE;
export const SYNC_TYPE_VALUE_OPTIONS = SYNC_TYPE_OPTIONS.map((option) => option.value);

export const SYNC_TYPE_DESCRIPTION = {
  [DISABLED_SYNC_TYPE]: '',
  [ALL_SYNC_TYPE]: "Sync all items, even if they're not associated with any location.",
  [EXCLUSIVE_SYNC_TYPE]: 'Sync only items that are explicitly configured for this location',
  [INCLUSIVE_SYNC_TYPE]:
    "Sync items configured for this location, plus items that aren't tied to any location.",
};
